/**
 * @title:
 * @fileName: ExportDownloads
 * @projectName WEB
 * @author ：yaaynn
 * @date ：2020/7/21 10:12
 * @modified By：
 * @version:     1.0$
 * @description: TODO
 */
class ExportDownloads {
    constructor(hostname, path = '/api') {
        this._api = hostname + path
        this._hostname = hostname
        this._path = path
    }

    //桥梁定期检查
    get download_bridgeRegularCheck_export (){
        return this._api + '/bridgetunneldataquery/download_getbridgeregularchecks_export'
    }
    //桥梁特殊检查
    get download_getbridgespecialchecks_export (){
        return this._api + '/bridgetunneldataquery/download_getbridgespecialchecks_export'
    }
    //涵洞经常检查
    get download_getculvertrunningchecks_export (){
        return this._api + '/bridgetunneldataquery/download_getculvertrunningchecks_export'
    }
    //涵洞定期检查
    get download_getculvertregularchecks_export (){
        return this._api + '/bridgetunneldataquery/download_getculvertregularchecks_export'
    }
    //入库导出
    get download_getmaterialenterstock_export (){
        return this._api + '/storagequery/download_getmaterialenterstock_export'
    }

}
export default ExportDownloads
